/**
 * `src/lib/audio/reciters.ts` — the reciters offered, by everyayah.com folder.
 *
 * SPEC §2.2: recitation audio is runtime-only from everyayah.com, which
 * publishes no site licence; copyright sits with the reciters and their
 * estates. The app links, it does not mirror.
 *
 * Every folder below was checked live on 2026-10-01 with a Range GET on
 * 001001, 002001, 002286, 009001 and 114006 — all 206 audio/mpeg — while a
 * made-up folder returns 404. Add a reciter only after the same check.
 */

export interface Reciter {
	/** the everyayah.com folder, which is also the stored `audio.reciter_id` */
	id: string;
	/** the reciter's name, in Arabic (DECISIONS D2) */
	name: string;
}

export const RECITERS: readonly Reciter[] = [
	{ id: 'Alafasy_64kbps', name: 'مشاري راشد العفاسي' },
	{ id: 'Husary_64kbps', name: 'محمود خليل الحصري' },
	{ id: 'Minshawy_Murattal_128kbps', name: 'محمد صديق المنشاوي (مرتّل)' },
	{ id: 'Abdul_Basit_Murattal_64kbps', name: 'عبد الباسط عبد الصمد (مرتّل)' },
	{ id: 'Abdurrahmaan_As-Sudais_64kbps', name: 'عبد الرحمن السديس' },
	{ id: 'Maher_AlMuaiqly_64kbps', name: 'ماهر المعيقلي' }
];

export const DEFAULT_RECITER_ID = 'Alafasy_64kbps';

/** The reciter for a stored id; an unknown or empty id gets the default. */
export function reciterOf(id: unknown): Reciter {
	return (
		RECITERS.find((r) => r.id === id) ??
		(RECITERS.find((r) => r.id === DEFAULT_RECITER_ID) as Reciter)
	);
}
